// Normaliseert backend-rollen naar frontend-permission keys
export function normalizeRole(role) {
  if (!role) return null;

  const map = {
    PlatformAdmin: "admin",
    Admin: "admin",
    Projectleider: "projectleider",
    Projectmanager: "projectleider",
    Werkvoorbereider: "werkvoorbereider",
    Monteur: "monteur",
    Onderaannemer: "onderaannemer",
    Subcontractor: "onderaannemer",
    KAM: "kam",
    Controller: "controller",
    Demo: "demo",
  };

  return map[role] || role.toLowerCase();
}
